import Pattern from './Pattern.i18n';

export default Pattern
export { Pattern as Base }